"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHONE_TOOL_URL = exports.BADGE_PHOTO_URL = exports.INVERTED_COLOR_SCHEME = exports.DEFAULT_COLOR_SCHEME = exports.sharedPropTypes = exports.layoutConstants = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _interfaces = require("./interfaces");

var layoutConstants = {
  xs: {
    imageSize: 24,
    imageSpacing: 8,
    nameFontSize: 'T200',
    nameFontWeight: 'medium',
    nameLineHeight: 1,
    textFontSize: 'T100',
    lineHeight: 1,
    spacing: 0,
    maxChildren: 0
  },
  s: {
    imageSize: 32,
    imageSpacing: 8,
    nameFontSize: 'T200',
    nameFontWeight: 'medium',
    nameLineHeight: 1,
    textFontSize: 'T100',
    lineHeight: 1,
    spacing: 4,
    maxChildren: 1
  },
  m: {
    imageSize: 48,
    imageSpacing: 16,
    nameFontSize: 'T200',
    nameFontWeight: 'medium',
    nameLineHeight: 1,
    textFontSize: 'T100',
    lineHeight: 1,
    spacing: 3,
    maxChildren: 2
  },
  l: {
    imageSize: 112,
    imageSpacing: 24,
    nameFontSize: 'T500',
    nameFontWeight: 'regular',
    nameLineHeight: 1,
    textFontSize: 'T300',
    lineHeight: 1,
    spacing: 12,
    maxChildren: 3
  }
};
exports.layoutConstants = layoutConstants;
var sharedPropTypes = {
  colorScheme: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.AvatarColorScheme)).description('Sets a predefined color scheme to use for the component.')
};
exports.sharedPropTypes = sharedPropTypes;
var DEFAULT_COLOR_SCHEME = {
  textColor: 'neutral100',
  linkColor: 'primary70'
};
exports.DEFAULT_COLOR_SCHEME = DEFAULT_COLOR_SCHEME;
var INVERTED_COLOR_SCHEME = {
  textColor: 'neutral0',
  linkColor: 'neutral0'
};
exports.INVERTED_COLOR_SCHEME = INVERTED_COLOR_SCHEME;
var BADGE_PHOTO_URL = 'https://internal-cdn.amazon.com/badgephotos.amazon.com/';
exports.BADGE_PHOTO_URL = BADGE_PHOTO_URL;
var PHONE_TOOL_URL = 'https://phonetool.amazon.com/users/';
exports.PHONE_TOOL_URL = PHONE_TOOL_URL;